module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"First Name":"First Name","Surname":"Surname"},"es":{"First Name":"Primer nombre","Surname":"Apellido"},"sw":{"First Name":"Jina la Kwanza","Surname":"Jina la Pili"}}')
  delete Component.options._Ctor
}
